// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"sy_a bho_b bho_bj","SubscribedPhotoblogs__link":"sy_b bho_a bho_r"};